<template>
  <div class="appointment-simple__row">
    <dr-icon
      :key="'healthInsuranceCard-icon'"
      ref="healthInsuranceCard-icon"
      name="healthInsuranceCard"
      fill="gray"
      class="appointment-simple__row-icon"
    />

    <div class="appointment-simple__row-wrapper">
      <div class="health-insurance">
        <!-- Plano de saúde -->
        <div
          v-click-outside="() => showPlans = false"
          class="health-insurance__info"
          @click="showHealthPlansList()"
        >
          <dr-autocomplete
            :ref="'healthInsurance_healthPlan'"
            :key="'healthInsurance_healthPlan'"
            :endpoint="'health_insurance'"
            :new-filter="true"
            :format="'{$name}'"
            :fields="['filterLike[hi.name]']"
            :return-format="'object'"
            :disabled="disableAutocomplete"
            :disable-local="true"
            :placeholder="placeholder"
            :value="chosenPlan"
            :class="[
              (healthPlan || chosenPlan) && 'has-value',
              (errorFields.includes('healthInsurance')) && 'has-error'
            ]"
            class="health-insurance__autocomplete"
            @change="healthPlanObject = $event"
            @input="hideSavedPlans($event); healthPlan = $event"
          />

          <div
            v-if="disableAutocomplete"
            class="clickable-area"
          />

          <!-- Listas de planos cadastrados -->
          <ul
            v-if="showPlans"
            class="health-insurance__plans"
          >
            <li
              v-for="(plan, index) of healthInsurancePlans"
              :key="`healthInsurancePlan_${index}`"
              class="health-insurance__plans-item"
              @click.stop.prevent="choosePlan(plan)"
            >
              {{ plan['health_insurance'].name }}
            </li>

            <li
              class="health-insurance__plans-item"
              @click.stop.prevent="newPlan()"
            >
              Cadastrar novo
            </li>
          </ul>
        </div>

        <!-- Número da carteirinha -->
        <div class="health-insurance__info">
          <dr-field
            :form.sync="formData.healthInsurance"
            :field.sync="formData.healthInsurance['walletNumber']"
            :value.sync="formData.healthInsurance['walletNumber'].value"
            :id="'healthInsurance_walletNumber'"
            :ref="'healthInsurance_walletNumber'"
            :key="'healthInsurance_walletNumber'"
            :class="[
              (formData.healthInsurance['walletNumber'].value) && 'has-value',
              (errorFields.includes('walletNumber')) && 'has-error'
            ]"
            class="appointment-simple__input"
            prefix="appointment-health-insurance_"
          />
        </div>

        <!-- Data de validade -->
        <div class="health-insurance__info">
          <dr-field
            :form.sync="formData.healthInsurance"
            :field.sync="formData.healthInsurance['walletValidity']"
            :value.sync="formData.healthInsurance['walletValidity'].value"
            :id="'healthInsurance_walletValidity'"
            :ref="'healthInsurance_walletValidity'"
            :key="'healthInsurance_walletValidity'"
            :class="[
              (formData.healthInsurance['walletValidity'].value) && 'has-value',
              (errorFields.includes('walletValidity')) && 'has-error'
            ]"
            class="appointment-simple__input"
            prefix="appointment-health-insurance_"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DrAutocomplete from '@/components/form/autocomplete'
import DrField from '@/components/form/field'

const formData = {
  healthInsurance: {
    healthPlan: {
      name: 'specialPatientHealthInsurance.healthInsurance',
      type: 'search',
      placeholder: 'Buscar convênio',
      disableLocal: true,
      disabled: false,
      hideErrors: true,
      endpoint: 'health_insurance',
      format: '{$name}',
      returnFormat: 'object',
      fields: ['fielterLike[hi.name]'],
      value: null
    },

    walletNumber: {
      name: 'specialPatientHealthInsurance.walletNumber',
      type: 'text',
      placeholder: 'Nº da carteira',
      value: null
    },

    walletValidity: {
      name: 'specialpatientHealthInsurance.walletValidity',
      type: 'text',
      mask: '##/##/####',
      placeholder: 'Validade',
      value: null
    }
  }
}

export default {
  name: 'DrAppointmentHealthInsurance',

  components: {
    DrAutocomplete,
    DrField
  },

  props: {
    healthInsurancePlans: {
      type: Array,
      required: false,
      default: () => []
    },

    errorFields: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data () {
    return {
      formData,
      healthPlan: null,
      healthPlanObject: {},
      disableAutocomplete: false,
      showPlans: false,
      chosenPlan: null,
      chosenPlanId: null,
      placeholder: (this.healthInsurancePlans && this.healthInsurancePlans.length > 0)
        ? 'Escolha o plano'
        : 'Buscar plano'
    }
  },

  computed: {
    healthPlanData () {
      return {
        id: (this.healthPlanObject && 'id' in this.healthPlanObject && this.healthPlanObject.id)
          ? this.healthPlanObject.id
          : (this.chosenPlanId) ? this.chosenPlanId : null,
        walletNumber: this.formData.healthInsurance.walletNumber.value,
        walletValidity: this.formData.healthInsurance.walletValidity.value,
        isSaved: !!this.chosenPlan
      }
    }
  },

  watch: {
    healthPlanData: {
      deep: true,
      immediate: false,
      handler (v) {
        this.$emit('on-choose-plan', v)
      }
    }
  },

  destroyed () {
    this.showPlans = false
    this.disableAutocomplete = false

    for (const prop in this.formData.healthInsurance) {
      this.formData.healthInsurance[prop].value = null
    }

    this.$emit(
      'on-choose-plan',
      {
        id: null,
        walletNumber: null,
        walletValidity: null,
        isSaved: false
      }
    )
  },

  methods: {
    hideSavedPlans (arg) {
      if (arg) this.showPlans = false
    },

    newPlan () {
      this.placeholder = 'Buscar plano'
      this.showPlans = false
      this.$refs['healthInsurance_healthPlan'].resetValues()

      this.formData.healthInsurance.healthPlan.value = null
      this.formData.healthInsurance.walletNumber.value = null
      this.formData.healthInsurance.walletValidity.value = null

      this.formData.healthInsurance.walletNumber.disabled = false
      this.formData.healthInsurance.walletValidity.disabled = false
      this.disableAutocomplete = false
      this.chosenPlan = null

      this.$refs['healthInsurance_healthPlan'].$el.querySelector('input').focus()
    },

    choosePlan (plan) {
      this.showPlans = false

      this.chosenPlanId = plan.id
      this.chosenPlan = plan['health_insurance'].name
      this.formData.healthInsurance.walletNumber.value = plan['wallet_number']
      this.formData.healthInsurance.walletValidity.value = this.$moment(plan['wallet_validity']).format('DD/MM/YYYY')

      this.disableAutocomplete = true
      // this.formData.healthInsurance.walletNumber.disabled = true
      // this.formData.healthInsurance.walletValidity.disabled = true
    },

    showHealthPlansList () {
      if (!this.formData.healthInsurance.healthPlan.value) {
        if (this.showPlans) {
          this.showPlans = false
        } else {
          this.showPlans = true
        }
      }

      if (this.disableAutomplete) {
        this.showPlans = !this.showPlans
      }

      if (this.healthPlan) {
        this.showPlans = false
      }
    }
  }
}
</script>
